import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { GruppoStudenti } from '../models/registro/gruppo-studenti';

import { AuthService } from './auth-service/auth-service';
import { StudenteClasse } from '../models/registro/studente-classe';
import { Rilevazione } from '../models/rilevazione-presenze/rilevazione';
import { Presenza } from '../models/rilevazione-presenze/presenza';
import { RilevazionePresenzeService } from './rilevazione-presenze-service';
import { UserService } from './user-service';

/**
 * Fornisce i servizi relativi alla gestione dei gruppi di studenti
 */
@Injectable( { providedIn: 'root' })
export class GruppiStudentiService {

  optionsContJson = {headers: new HttpHeaders({'Content-Type':  'application/json'})};

  constructor(
      public http: HttpClient,
      public authService: AuthService,
      public userService: UserService,
      public rilevazionePresenzeService: RilevazionePresenzeService
    ) {
    console.log('Hello GruppiStudentiService Provider');
  }

  aggiungiPresenzeOAssenza(studentiGruppo: StudenteClasse[], rilevazione: Rilevazione, asAssenze: boolean): Observable<StudenteClasse[]> {
    const idOperatore = this.userService.getUtenteCorrente().id;
    const body = { studentiClasse: this.simplifyStudentiClasse(studentiGruppo, false) };
    return this.http.put(`registro/presenze/${rilevazione.id}/${idOperatore}/${asAssenze}`, body, this.optionsContJson).pipe(
      map(r => this.parseResponseClasseStudenti(r)));
  }

  addNewGruppo(idGruppo: number, descGruppo: string): Observable<GruppoStudenti> {
    const post = { id: idGruppo, descrizione: descGruppo , adLogId: this.authService.getAdLogId()};
    return this.http.put('registro/gruppo', JSON.stringify(post), this.optionsContJson).pipe(
      map(r => this.parseGruppoResponse(r))
      );
  }

  rimuoviGruppo(gruppo: GruppoStudenti): Observable<any> {
    return this.http.delete(`registro/gruppo/${gruppo.id}`,  this.optionsContJson)
      .pipe(map(r => {}));
  }

  simplifyStudentiClasse(studentiClasse: StudenteClasse[], salvaStudenti: boolean): StudenteClasse[] {
    const localStudenti = [];
    for (const s of studentiClasse) {

      if (salvaStudenti && localStudenti.length === 0) {
        // aggiunge un record fittizio utilizzato per gestire
        // la rimozione di tutti gli studenti dai gruppi
        // tslint:disable-next-line:max-line-length
        const sc: StudenteClasse = { 'id': -1, 'idStudente': '-1', 'matricola': '-1', 'idAttivitaReale': s.idAttivitaReale, 'idGruppo': -1 };
        localStudenti.push(sc);
      }
      // vanno salvati solo gli studenti con gruppo.
      // Quelli rimossi dai gruppi saranno intercettati dal be da un confronto con quelli presenti sul db
      // all'elenco gli studenti vanno aggiunti anche in fase di inserimento delle presenze ( "!salvaStudenti" )
      if (s.idGruppo || !salvaStudenti) {
        // tslint:disable-next-line:max-line-length
        const sc: StudenteClasse = { 'id': s.id, 'idStudente': s.idStudente, 'matricola': s.matricola, 'idAttivitaReale': s.idAttivitaReale, 'idGruppo': s.idGruppo , 'nome': s.nome, 'cognome': s.cognome };
        localStudenti.push(sc);
      }
    }
    return localStudenti;
  }

  salvaStudentiClasse(studentiClasse: StudenteClasse[]): Observable<StudenteClasse[]> {
    const body = { studentiClasse: this.simplifyStudentiClasse(studentiClasse, true) };
    return this.http.put('registro/studenti', body, this.optionsContJson).pipe(
      map(r => this.parseResponseClasseStudenti(r)));

  }

  cercaClasseStudentiPerAdLogId(adLogId: number):  Observable<any[]> {
    const url = 'registro/classe/' + adLogId;
    return this.http.get(url)
      .pipe(map(r => this.parseResponseClasseStudenti(r)));
  }

  private parseResponseClasseStudenti(response: any): StudenteClasse[] {
    if (response instanceof HttpErrorResponse) {
      throw response;
    } else {
      const json = response; // .json();
      const data: StudenteClasse[] = (Array.isArray(json)) ? json : Array.of(json);
      this.toStudentiClasseSmart(data);
      console.log('classe', data);
      return data;
    }
  }

  public toStudentiClasseSmart(studenti: StudenteClasse[]) {
   for (const f of studenti) {
     f.descrizione = function () {
        return (f) ? f.cognome + ' ' + f.nome : 'N.D.' ;
     };
     if (f.presenza) {
       this.rilevazionePresenzeService.toPresenzaSmart( f.presenza );
     }
    }
  }

  cercaGruppiStudentiPerAdLogId(adLogId: number):  Observable<any[]> {
    const url = 'registro/gruppo/' + adLogId;
    return this.http.get(url)
      .pipe(map(r => this.parseResponseGruppi(r)));
  }

    // --------------------------------------------------------------


  private parseResponseGruppi(response: any): GruppoStudenti[] {
    if (response instanceof HttpErrorResponse) {
      throw response;
    } else {
      const json = response; // .json();
      const data: GruppoStudenti[] = (Array.isArray(json)) ? json : Array.of(json);
      console.log('GruppiStudenti', data);
      return data;
    }
  }


  private parseGruppoResponse(response: any): GruppoStudenti {
    if (response instanceof HttpErrorResponse) {
      throw response;
    } else {
      const data: GruppoStudenti = response;
      console.log('gruppo', data);
      return data;
    }
  }

}
